export const tradingFlowSteps = [
  {
    no: '01',
    icon: 'ri-focus-3-line',
    title: 'เลือกคู่เงินและไทม์เฟรม',
    desc: 'เริ่มจากคู่เงินที่สภาพคล่องสูงอย่าง EUR/USD แล้วเลือกไทม์เฟรมให้ตรงกับเวลาที่คุณมีจริง อย่ากระโดดไปมาหลายคู่ในสัปดาห์เดียว',
    accent: false,
    path: '/how-to-trade-forex',
    linkLabel: 'อ่านแผนเทรด 6 ขั้นตอน',
  },
  {
    no: '02',
    icon: 'ri-draft-line',
    title: 'กำหนดจุดเข้าและจุดตัดขาดทุน',
    desc: 'วางแนวรับแนวต้านก่อน แล้วค่อยกำหนดระยะ Stop Loss จากโครงสร้างราคาจริง ไม่ใช่ตัวเลขกลม ๆ ที่รู้สึกว่าสวย',
    accent: true,
    path: '/support-resistance',
    linkLabel: 'อ่านเรื่องแนวรับแนวต้าน',
  },
  {
    no: '03',
    icon: 'ri-money-dollar-circle-line',
    title: 'เช็กต้นทุนก่อนกด',
    desc: 'ดู Spread ปัจจุบันในช่วงเวลานั้น และเปิดปฏิทินข่าว ถ้าต้นทุนสูงเกินกว่าที่แผนรับได้ ให้ข้ามไม้นั้นแทนที่จะฝืนเข้า',
    accent: false,
    path: '/forex-execution-cost',
    linkLabel: 'อ่านเรื่องต้นทุนการเทรด',
  },
  {
    no: '04',
    icon: 'ri-list-settings-line',
    title: 'เลือกประเภทคำสั่งให้ตรงแผน',
    desc: 'Market เมื่อต้องเข้าทันที Limit เมื่อรอราคาย้อน Stop เมื่อรอราคาเบรก ถ้าตั้งผิดฝั่ง แพลตฟอร์มจะปฏิเสธคำสั่งทันที',
    accent: true,
    path: '/forex-order-types',
    linkLabel: 'อ่านเรื่องประเภทคำสั่ง',
  },
  {
    no: '05',
    icon: 'ri-add-circle-line',
    title: 'เปิดออเดอร์พร้อม SL / TP',
    desc: 'กรอกขนาดล็อตตามที่คำนวณไว้ ตั้ง Stop Loss และ Take Profit ในหน้าต่างคำสั่งเดียวกัน แล้วตรวจตัวเลขอีกครั้งก่อนยืนยัน',
    accent: false,
    path: '/how-to-place-order',
    linkLabel: 'อ่านขั้นตอนเปิดออเดอร์',
  },
  {
    no: '06',
    icon: 'ri-flag-2-line',
    title: 'ปิดออเดอร์ตามแผน',
    desc: 'ปิดเต็มจำนวนเมื่อถึงเป้าหรือจุดตัดขาดทุน หรือทยอยปิดบางส่วนตามสัดส่วนที่เขียนไว้ตั้งแต่ก่อนเปิด ไม่ใช่ตามอารมณ์',
    accent: true,
    path: '/closing-forex-positions',
    linkLabel: 'อ่านวิธีปิดออเดอร์',
  },
];

export const orderTypeGuides = [
  {
    key: 'market',
    name: 'Market Order',
    thai: 'เข้าทันทีที่ราคาปัจจุบัน',
    icon: 'ri-flashlight-line',
    when: 'สัญญาณเกิดตรงหน้าพอดี และคุณต้องการอยู่ในตลาดเดี๋ยวนี้ ไม่ต้องการรอราคา',
    entry: 'จับคู่ที่ราคาตลาด ณ วินาทีที่กดยืนยัน',
    pros: ['จับคู่ทันที ไม่มีคำสั่งค้าง', 'เหมาะกับคนที่ดูกราฟสดและตัดสินใจเร็ว'],
    cautions: ['มีโอกาสเจอสลิปเพจตอนราคาเคลื่อนเร็ว', 'ราคาที่ได้อาจต่างจากตัวเลขที่เห็นบนจอ'],
  },
  {
    key: 'limit',
    name: 'Buy / Sell Limit',
    thai: 'รอราคาย้อนมาถึงจุดที่ตั้งไว้',
    icon: 'ri-arrow-go-back-line',
    when: 'มีแนวรับแนวต้านชัดเจน และอยากได้ราคาเข้าที่ดีกว่าราคาปัจจุบัน',
    entry: 'Buy Limit ต่ำกว่าราคาปัจจุบัน · Sell Limit สูงกว่าราคาปัจจุบัน',
    pros: ['ได้ราคาตามที่วางแผนไว้ล่วงหน้า', 'ไม่ต้องเฝ้าจอตลอดเวลา'],
    cautions: ['อาจไม่ถูกจับคู่เลยถ้าราคาไม่ย้อนมา', 'ต้องกำหนดวันหมดอายุของคำสั่ง'],
  },
  {
    key: 'stop',
    name: 'Buy / Sell Stop',
    thai: 'รอราคาเบรกผ่านจุดหนึ่งก่อน',
    icon: 'ri-arrow-right-up-line',
    when: 'เทรดตามการเบรกแนวรับแนวต้าน และต้องการหลักฐานว่าเทรนด์ไปต่อจริง',
    entry: 'Buy Stop สูงกว่าราคาปัจจุบัน · Sell Stop ต่ำกว่าราคาปัจจุบัน',
    pros: ['เข้าหลังราคายืนยันทิศทางแล้ว', 'เหมาะกับแผนเทรดตามเทรนด์'],
    cautions: ['ช่วงเบรกอาจเจอสลิปเพจและราคาย้อนกลับ', 'ตั้งใกล้ราคาเกินไปอาจโดนลากก่อนกลับตัว'],
  },
];

export type ExecutionCost = {
  label: string;
  icon: string;
  desc: string;
  example: string;
  extra?: string;
  accent: boolean;
};

export const executionCosts: ExecutionCost[] = [
  {
    label: 'Spread',
    icon: 'ri-arrow-left-right-line',
    desc: 'ส่วนต่างราคา Bid–Ask ที่ถูกหักทันทีที่เปิดออเดอร์',
    example: 'EUR/USD 0.8 pip ≈ 8 USD ต่อ 1 ล็อต',
    extra:
      'ช่วงเปิดตลาดวันจันทร์และตอนข่าวใหญ่อาจกว้างขึ้น 2–5 เท่า คู่เงินรองที่สภาพคล่องน้อยก็กว้างกว่าคู่หลักเสมอ',
    accent: false,
  },
  {
    label: 'Commission',
    icon: 'ri-receipt-line',
    desc: 'ค่าธรรมเนียมโบรกเกอร์ คิดต่อล็อตต่อรอบการเปิด-ปิด',
    example: 'บัญชี ECN ประมาณ 7 USD ต่อล็อตไป-กลับ',
    extra:
      'บัญชี Standard มักรวมต้นทุนนี้ไว้ใน Spread แล้วจึงไม่คิดแยก ส่วนบัญชี ECN คิดเป็นรายล็อตทุกครั้งที่เปิดและปิด',
    accent: true,
  },
  {
    label: 'Swap',
    icon: 'ri-calendar-todo-line',
    desc: 'ค่าถือสถานะข้ามคืน บวกหรือลบตามส่วนต่างดอกเบี้ยของสองสกุล',
    example: 'ถือข้ามคืนอาจได้หรือจ่ายราว 0.5–3 USD ต่อล็อต',
    extra:
      'คืนวันพุธคิด 3 เท่า เพราะชดเชยวันเสาร์–อาทิตย์ที่ตลาดปิด ดูอัตราของแต่ละคู่ได้ที่สเปกสัญญา (Contract Specifications) ในแพลตฟอร์ม',
    accent: false,
  },
  {
    label: 'Slippage',
    icon: 'ri-speed-up-line',
    desc: 'ราคาที่จับคู่ได้ต่างจากราคาที่เห็นตอนกดคำสั่ง',
    example: 'ช่วงข่าวสำคัญอาจต่างกัน 1–3 pip',
    extra:
      'เกิดง่ายที่สุดตอนข่าวเศรษฐกิจใหญ่และตอนตลาดเปิดวันจันทร์ ช่วงนั้นแม้แต่ Stop Loss ก็อาจถูกจับคู่ผิดจากที่ตั้งไว้',
    accent: true,
  },
];

export const costTable = [
  {
    pair: 'EUR/USD',
    standard: { spread: '0.8 pip', total: '≈ 8 USD' },
    ecn: { spread: '0.2 pip', commission: '7 USD', total: '≈ 9 USD' },
  },
  {
    pair: 'GBP/USD',
    standard: { spread: '1.2 pip', total: '≈ 12 USD' },
    ecn: { spread: '0.4 pip', commission: '7 USD', total: '≈ 11 USD' },
  },
  {
    pair: 'USD/JPY',
    standard: { spread: '1.0 pip', total: '≈ 6.8 USD' },
    ecn: { spread: '0.2 pip', commission: '7 USD', total: '≈ 8.4 USD' },
  },
  {
    pair: 'XAU/USD',
    standard: { spread: '0.25 USD', total: '≈ 25 USD' },
    ecn: { spread: '0.12 USD', commission: '7 USD', total: '≈ 19 USD' },
  },
];

export const costCalculatorPairs = [
  { symbol: 'EUR/USD', pipValue: 10, standardPerLot: 8, ecnSpreadPerLot: 2, commissionPerLot: 7 },
  { symbol: 'GBP/USD', pipValue: 10, standardPerLot: 12, ecnSpreadPerLot: 4, commissionPerLot: 7 },
  { symbol: 'USD/JPY', pipValue: 6.8, standardPerLot: 6.8, ecnSpreadPerLot: 1.4, commissionPerLot: 7 },
  { symbol: 'XAU/USD', pipValue: 1, standardPerLot: 25, ecnSpreadPerLot: 12, commissionPerLot: 7 },
];

export const costImpactScenarios = [
  {
    label: 'ไม้สั้น 5 pip',
    target: '5 pip',
    cost: '0.8 pip',
    percent: '16%',
    barWidth: '16%',
    note: 'ทุก 6 ไม้ที่ชนะ จะมี 1 ไม้ที่กำไรหายไปกับต้นทุนก่อนราคาจะเดินถึงเป้า',
  },
  {
    label: 'ไม้ระหว่างวัน 20 pip',
    target: '20 pip',
    cost: '0.8 pip',
    percent: '4%',
    barWidth: '4%',
    note: 'ต้นทุนเดิม แต่เป้าไกลขึ้น 4 เท่า สัดส่วนที่ถูกกินจึงเหลือไม่ถึงหนึ่งในสี่',
  },
  {
    label: 'ถือหลายวัน 60 pip',
    target: '60 pip',
    cost: '0.8 pip',
    percent: '1.3%',
    barWidth: '1.5%',
    note: 'ถือข้ามคืนจะเริ่มมี Swap เข้ามาแทน แต่ Spread แทบไม่มีผลกับผลลัพธ์แล้ว',
  },
];

export const marketSessions = [
  {
    name: 'โตเกียว',
    hours: '07:00 – 16:00',
    start: 7,
    end: 16,
    tone: 'background',
    pairs: 'JPY · AUD · NZD',
    note: 'ช่วงเช้าตลาดเอเชีย สภาพคล่องปานกลาง เหมาะกับคู่เงินเยน',
  },
  {
    name: 'ลอนดอน',
    hours: '14:00 – 23:00',
    start: 14,
    end: 23,
    tone: 'primary',
    pairs: 'EUR · GBP · CHF',
    note: 'ปริมาณซื้อขายมากที่สุดของวัน Spread ของคู่เงินหลักมักแคบที่สุด',
  },
  {
    name: 'นิวยอร์ก',
    hours: '19:30 – 04:30',
    start: 19.5,
    end: 28.5,
    tone: 'accent',
    pairs: 'USD · XAU · ดัชนี',
    note: 'ช่วงข่าวเศรษฐกิจสหรัฐฯ ราคาแกว่งแรงและสลิปเพจเกิดง่าย',
  },
];

export const executionMistakes = [
  {
    title: 'ไล่ราคาด้วย Market Order',
    symptom: 'เห็นราคาวิ่งแรงแล้วกดเข้าทันที ผลคือได้ราคาแย่กว่าที่วางแผนไว้',
    fix: 'ถ้าแผนไม่ได้บอกให้เข้าตรงนั้น ให้ใช้ Limit รอราคาย้อน หรือปล่อยไม้นี้ไป',
  },
  {
    title: 'ไม่ตั้ง Stop Loss เพราะกลัวโดนตัด',
    symptom: 'ขาดทุนลอยตัวค้างในพอร์ตจนต้องเติมเงินหรือปิดด้วยขาดทุนก้อนใหญ่',
    fix: 'ตั้ง Stop Loss ทุกครั้งพร้อมกับตอนเปิดออเดอร์ ไม่ใช่ค่อยมาคิดทีหลัง',
  },
  {
    title: 'ล็อตใหญ่กว่าที่คำนวณไว้',
    symptom: 'มั่นใจมากเป็นพิเศษแล้วเพิ่มล็อตเอง ผลคือขาดทุนหนึ่งไม้กินหลายวัน',
    fix: 'ยึดขนาดล็อตจากความเสี่ยงต่อออเดอร์ ไม่ปรับตามความมั่นใจ',
  },
  {
    title: 'เปิดหลายออเดอร์ทิศเดียวกัน',
    symptom: 'Buy EUR/USD, GBP/USD และ XAU/USD พร้อมกัน ความเสี่ยงจริงจึงทับกันหลายเท่า',
    fix: 'รวมความเสี่ยงของออเดอร์ที่สัมพันธ์กันเป็นก้อนเดียว ไม่เกินเพดานต่อวัน',
  },
  {
    title: 'เทรดช่วงข่าวใหญ่โดยไม่ดูปฏิทิน',
    symptom: 'Spread กว้างขึ้นหลายเท่าและราคากระโดดข้าม Stop Loss ในวินาทีเดียว',
    fix: 'เช็กปฏิทินเศรษฐกิจก่อนเปิดออเดอร์ และเว้นช่วง 15–30 นาทีรอบข่าวสำคัญ',
  },
  {
    title: 'ปิดออเดอร์ก่อนถึงแผนเพราะกลัวกำไรหาย',
    symptom: 'กำไรเล็ก ๆ สะสมไม่พอชดเชยขาดทุนเต็มจำนวนตอนที่แพ้',
    fix: 'เขียนจุดปิดไว้ล่วงหน้า หรือใช้ Partial Close แทนการปิดทั้งหมดด้วยความกลัว',
  },
];

export const preTradeChecklist = [
  'เลือกคู่เงินและไทม์เฟรมตรงกับแผนที่เขียนไว้แล้ว',
  'รู้จุดเข้า จุดตัดขาดทุน และเป้าหมายครบทั้งสามจุด',
  'คำนวณขนาดล็อตจากความเสี่ยงต่อออเดอร์แล้ว',
  'ตรวจ Spread ปัจจุบันแล้วว่าอยู่ในระดับปกติของคู่นั้น',
  'ไม่มีข่าวเศรษฐกิจสำคัญในช่วงที่ Stop Loss ทำงาน',
  'เลือกประเภทคำสั่งตรงกับแผน (Market / Limit / Stop)',
  'เตรียมบันทึกเหตุผลและผลลัพธ์หลังปิดออเดอร์',
];

export const tradingFaqs = [
  {
    q: 'Market Order กับ Limit Order ต่างกันแค่ไหน',
    a: 'Market Order เข้าทันทีที่ราคาปัจจุบัน ได้ความแน่นอนว่าได้เข้า แต่ราคาอาจคลาดจากที่เห็น ส่วน Limit Order รอให้ราคามาถึงระดับที่กำหนดก่อน จึงได้ราคาที่ดีกว่า แต่มีความเป็นไปได้ที่จะไม่ได้เข้าเลยถ้าราคาไม่ย้อนมา',
  },
  {
    q: 'ทำไมเพิ่งเปิดออเดอร์ก็ติดลบทันที',
    a: 'เพราะ Spread ถูกหักทันทีที่ออเดอร์ทำงาน ราคาต้องเดินไปเกิน Spread ก่อนจึงจะเริ่มเป็นกำไร เป็นเรื่องปกติของการเทรด ไม่ได้แปลว่าโบรกเกอร์โกง',
  },
  {
    q: 'ตั้ง Buy Stop ไว้ต่ำกว่าราคาปัจจุบันได้ไหม',
    a: 'ไม่ได้ เพราะ Buy Stop ต้องอยู่สูงกว่าราคาปัจจุบันเพื่อรอการเบรกขึ้น ถ้าต้องการรอราคาย้อนลงมาให้ใช้ Buy Limit แทน แพลตฟอร์มจะปฏิเสธคำสั่งที่ตั้งผิดฝั่ง',
  },
  {
    q: 'ต้องมีเงินเท่าไรจึงเริ่มเทรดได้',
    a: 'หลายโบรกเกอร์เปิดบัญชีขั้นต่ำได้ตั้งแต่หลักสิบดอลลาร์ แต่จำนวนเงินสำคัญน้อยกว่าการกำหนดความเสี่ยงต่อออเดอร์ ควรใช้เงินที่ยอมเสียได้และจำกัดความเสี่ยงไว้ที่ 1–2% ของพอร์ตต่อไม้',
  },
  {
    q: 'ควรเทรดวันละกี่ออเดอร์',
    a: 'ไม่มีตัวเลขตายตัว คุณภาพสำคัญกว่าปริมาณ เทรดเฉพาะเมื่อมีสัญญาณตรงตามแผน บันทึกจำนวนออเดอร์และผลลัพธ์ไว้ แล้วจะเห็นเองว่าช่วงใดที่คุณตัดสินใจได้ดีที่สุด',
  },
  {
    q: 'ต้องตั้ง Stop Loss ทุกครั้งจริงหรือ',
    a: 'จริงสำหรับมือใหม่ เพราะเป็นเครื่องมือเดียวที่จำกัดความเสียหายได้แน่นอนเมื่อตลาดผิดจากที่คิด ถ้าอยากให้Stop Loss ทำงานได้จริง ต้องตั้งจากโครงสร้างราคา ไม่ใช่ระยะที่ใกล้จนโดนตัดง่าย',
  },
];